import { adapterTimePricing } from 'features/timesPrice';

import { CoachesList, CoachesListServer, CoachInfo, CoachInfoServer } from '../store/types';

import { getImgUrl } from './../../imagesStore/utils/adapter';

export const adapteCouchInfo = ({ metainfo, image_id, ...res }: CoachInfoServer): CoachInfo => ({
  ...res,
  imageId: image_id,
  imageUrl: getImgUrl(image_id),
  metainfo: {
    pricing: adapterTimePricing(metainfo.pricing),
    description: metainfo.description,
    rating: Number(metainfo.rating)
  }
});

export const adapteCoachesList = (courts: CoachesListServer): CoachesList => courts.map(adapteCouchInfo).sort((a, b) => a.id - b.id);
